import styled from "@emotion/styled";
import { GelCaption, GelCol, GelIcon, GelLink, GelRow } from "@tal-gel/components";
import { getGelTokens } from "@tal-gel/theming";

const PageFooter = () => {
  return (
    <Footer>
      <FooterContent>
        <FooterTop>
          <img
            style={{ marginTop: getGelTokens().global.sizeBaseX2 }}
            alt="TAL Logo"
            src={process.env.PUBLIC_URL + "/images/logo.svg"}
            height={getGelTokens().global.sizeBaseX6}
            width={getGelTokens().global.sizeBaseX16}
          ></img>
          <GelRow style={{ width: "100%" }}>
            <GelCol sm={12} md={12} lg={4}>
              <div style={{ width: "100%" }}>
                <FooterLink>
                  <a href="https://www.tal.com.au/privacy-policy" target="_blank" rel="noreferrer">
                    Privacy Policy
                  </a>
                </FooterLink>
                <FooterLink>
                  <a
                    href="https://www.tal.com.au/-/media/tal/files/fsg/financial_services_guide.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Financial Services Guide
                  </a>
                </FooterLink>
                <FooterLink>
                  <a
                    href="https://www.tal.com.au/about-us/documents-and-forms#:~:text=Complaints-,Documents%20and%20forms,-Sitemap"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Documents and forms
                  </a>
                </FooterLink>
              </div>
            </GelCol>
            <GelCol sm={12} md={12} lg={4}>
              <div style={{ width: "100%" }}>
                <FooterLink>
                  <a href="https://www.tal.com.au/security" target="_blank" rel="noreferrer">
                    Security
                  </a>
                </FooterLink>
                <FooterLink>
                  <a
                    href="https://www.tal.com.au/slice-of-life-blog"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Slice of Life blog
                  </a>
                </FooterLink>
                <FooterLink>
                  <a href="https://www.tal.com.au/sitemap" target="_blank" rel="noreferrer">
                    Sitemap
                  </a>
                </FooterLink>
              </div>
            </GelCol>
            <GelCol sm={12} md={12} lg={4}>
              <div style={{ width: "100%" }}>
                <FooterLink>
                  <a href="https://www.tal.com.au/disclaimer" target="_blank" rel="noreferrer">
                    Disclaimer
                  </a>
                </FooterLink>
                <FooterLink>
                  <a
                    href="https://www.tal.com.au/contact-us/complaint-handling-process"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Complaints
                  </a>
                </FooterLink>
                <FooterLink>
                  <a
                    href="https://www.tal.com.au/code-of-practice"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Life Insurance Code of Practice
                  </a>
                </FooterLink>
              </div>
            </GelCol>
            {/* <GelCol sm={12} md={12} lg={2}>
              <div style={{ width: "100%" }}>Test</div>
            </GelCol> */}
          </GelRow>
        </FooterTop>
        <FooterDisclaimer>
          <GelCaption style={{ color: getGelTokens().global.themeColorGrayT30 }}>
            2023 © TAL Services Limited a{" "}
            <GelLink
              href="https://www.dai-ichi-life-hd.com/en/"
              target="_blank"
              rel="noreferrer"
              style={{ color: getGelTokens().global.themeColorGrayT30 }}
            >
              Dai-ichi Life Group
              <GelIcon
                inline
                name="ExternalLink"
                color={getGelTokens().global.themeColorIconDefault}
                width={getGelTokens().global.sizeBaseX3}
              ></GelIcon>
            </GelLink>
            Company.
            <br />
            <br />
            "TAL is Australia's leading life insurer" based on Inforce premiums for risk only life
            insurance policies, NMG Consulting (2021).
            <br />
            <br />
            Any financial product advice is general in nature only and does not take into account
            any person’s objectives, financial situation or needs. Before acting on it, the
            appropriateness of the advice for any person should be considered, having regard to
            those factors. Persons deciding whether to acquire or continue to hold life insurance
            issued by TAL should consider the relevant{" "}
            <GelLink
              href="https://www.tal.com.au/about-us/documents-and-forms"
              target="_blank"
              rel="noreferrer"
              style={{ color: getGelTokens().global.themeColorGrayT30 }}
            >
              {" "}
              Product Disclosure Statement (PDS)
            </GelLink>
            .{" "}
            <GelLink
              href="https://www.tal.com.au/about-us/documents-and-forms"
              target="_blank"
              rel="noreferrer"
              style={{ color: getGelTokens().global.themeColorGrayT30 }}
            >
              {" "}
              The Target Market Determination(TMD)
            </GelLink>{" "}
            for the product (where applicable) is also available. Life insurance issued by TAL Life
            Limited ABN 70 050 109 450 AFSL 237848.
          </GelCaption>
        </FooterDisclaimer>
      </FooterContent>
    </Footer>
  );
};

export default PageFooter;

const Footer = styled.div`
  background-color: ${getGelTokens().global.themeColorBackgroundDark};
  color: white;
`;

const FooterContent = styled.div`
  max-width: 1040px;
  margin: 0 auto;
  padding-top: 40px;
  padding-bottom: 40px;

  @media (max-width: ${getGelTokens().global.breakpointSmall}px) {
    padding-left: 16px;
    padding-right: 16px;
    width: 100%;
    padding-bottom: 156px;
  }
`;

const FooterTop = styled.div`
  display: flex;
  width: 100%;
  gap: 32px;
  align-items: start;
  align-content: start;

  @media (max-width: ${getGelTokens().global.breakpointSmall}px) {
    flex-direction: column;
  }
`;

const FooterLink = styled.div`
  font-family: ${getGelTokens().global.fontFamilySans};
  font-size: ${getGelTokens().global.fontSizeBodySmall}px;
  padding-bottom: ${getGelTokens().global.sizeBaseX2}px;
  padding-top: ${getGelTokens().global.sizeBaseX2}px;
  margin-top: ${getGelTokens().global.sizeBaseX2}px;
  border-bottom: 1px solid ${getGelTokens().global.themeColorGrayT80};
  width: 100%;

  &:hover {
    border-bottom: 1px solid ${getGelTokens().global.themeColorGrayT50};
    cursor: pointer;
  }

  a {
    color: ${getGelTokens().global.themeColorTextInverse};
    text-decoration: none;
  }
`;

const FooterDisclaimer = styled.div`
  padding-top: 32px;
  padding-bottom: 32px;
`;
